module.exports = __webpack_public_path__ + "static/media/S4N7-5.4a2d7efa.svg";